<template>
	<div class="social-buttons-group">
		<bi-button
			type="icon"
			color="transparent"
			to="https://www.facebook.com/BohemiaInteractive"
			target="_blank"
		>
			<i class="icon bis-fb" />
		</bi-button>
		<bi-button
			type="icon"
			color="transparent"
			to="https://twitter.com/bohemiainteract"
			target="_blank"
		>
			<i class="icon bis-x" style="width: 20px; height: 35px;" />
		</bi-button>
		<bi-button
			type="icon"
			color="transparent"
			to="https://www.youtube.com/user/BohemiaInteract"
			target="_blank"
		>
			<i class="icon bis-yt" />
		</bi-button>
		<bi-button
			type="icon"
			color="transparent"
			to="https://www.linkedin.com/company/bohemia-interactive/"
			target="_blank"
		>
			<i class="icon bis-in" />
		</bi-button>
	</div>
</template>

<script>
import BiButton from "./Button";

export default {
	name: "BiSocialButtons",
	components: {
		BiButton
	},
	data() {
		return {
			cdn: "https://static.bistudio.com/bohemia-net/svg/",
			facebook: "social-icons/facebook.svg",
			twitter: "social-icons/x-logo.svg",
			youtube: "social-icons/youtube.svg",
			linkedin: "social-icons/linkedin.svg"
		};
	},
	methods: {}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/icons/style.scss";

.social-buttons-group {
	white-space: nowrap;

	a {
		margin-right: 4px;
	}

	i {
		font-size: 25px;
		color: black;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/coppiedFooter/Social-Buttons.vue